// Configurations
import generalRules from 'config/rules.json5';
import kronosRules from 'config/kronosRules.json5';
import targetingWhitelist from 'config/targetingWhitelist.json5';
import slotDefinitions from 'config/slotDefinitions.json5';
import configuration from 'config/configuration.json5';
import dfpEnvironment from 'config/dfpEnvironment.json5';
import golfConfiguration from 'config/golf.json5';
import foodComConfiguration from 'config/foodCom.json5';

import slotDefinitionsWeb from 'config/slotDefinitionsWeb.json5';
import slotDefinitionsMobile from 'config/slotDefinitionsMobile.json5';
import slotDefinitionsResponsive from 'config/slotDefinitionsResponsive.json5';

import layoutsCoreCommon from 'config/layouts/core/common.json5';
import layoutsCoreSweepstakesThanks from 'config/layouts/core/sweepstakes|thanks.json5';
import layoutsFullWidthCommon from 'config/layouts/fullwidth/common.json5';
import layoutsFullWidthArticlePage from 'config/layouts/fullwidth/articlePage.config.yaml';
import layoutsFullWidthPhotoGalleryPage from 'config/layouts/fullwidth/photogallerypage.json5';
import layoutsShowPage from 'config/layouts/core/showpage.config.yaml';
import layoutsCoreRecipePage from 'config/layouts/core/recipe.json5';
import layoutsCoreArticlePage from 'config/layouts/core/articlepage.json5';
import layoutsCoreVotePage from 'config/layouts/core/votepage.json5';
import layoutsCorePhotoLibraryCollectionPage from 'config/layouts/core/photolibrarycollectionpage.json5';
import layoutsCorePhotoLibraryViewerPage from 'config/layouts/core/photolibraryviewerpage.json5';
import layoutsCorePhotoPage from 'config/layouts/core/photo.json5';
import layoutsCoreLandingPage from 'config/layouts/core/landingpage.json5';
import layoutsCoreUniversalLandingPage from 'config/layouts/core/universallandingpage.json5';
import layoutsCorePhotoGalleryPage from 'config/layouts/core/photogallerypage.json5';
import layoutsCoreSiteSearchPageSponsorship from 'config/layouts/core/sitesearchpage|sponsorship.json5';
import layoutsCoreSweepstakesSponsorship from 'config/layouts/core/sweepstakes|sponsorship.json5';
import layoutsCoreSweepstakes from 'config/layouts/core/sweepstakes.json5';
import layoutsCoreHome from 'config/layouts/core/home.json5';
import layoutsCoreSitemap from 'config/layouts/core/sitemap.json5';
import layoutsCoreFullWidthPage from 'config/layouts/core/fullwidthpage.json5';
import layoutsDTCWebCommon from 'config/layouts/dtc-web/common.json5';
import layoutsCoreGaladVerticalPhotoGallery from 'config/layouts/core/galadVerticalPhotoGallery.json5';

import layoutsFoodcomCommon from 'config/layouts/foodcom/common.config.yaml';
import layoutsFoodcomSCC3 from 'config/layouts/foodcom/scc3.config.yaml';
import layoutsFoodcomSitemap from 'config/layouts/foodcom/sitemap.config.yaml';
import layoutsFoodcomHome from 'config/layouts/foodcom/home.config.yaml';
import layoutsFoodcomRecipe from 'config/layouts/foodcom/recipe.config.yaml';
import layoutsFoodcomFoodDictionary from 'config/layouts/foodcom/food_dictionary.config.yaml';
import layoutsFoodcomCardLayout from 'config/layouts/foodcom/card-layout.config.yaml';

// Other header bidding partner configurations
import amazonA9 from './config/amazonA9.json5';

type Configuration = Array<{ [key: string]: unknown }>;

export default function buildConfiguration(): Configuration {
	const layoutConfiguration: Configuration = [
		...layoutsCoreCommon as Configuration,
		...layoutsFullWidthCommon as Configuration,
		...layoutsCorePhotoGalleryPage as Configuration,
		...layoutsCoreSweepstakesThanks as Configuration,
		...layoutsCoreRecipePage as Configuration,
		...layoutsCoreArticlePage as Configuration,
		...layoutsCoreVotePage as Configuration,
		...layoutsFullWidthArticlePage as Configuration,
		...layoutsFullWidthPhotoGalleryPage as Configuration,
		...layoutsCorePhotoLibraryCollectionPage as Configuration,
		...layoutsCorePhotoLibraryViewerPage as Configuration,
		...layoutsCorePhotoPage as Configuration,
		...layoutsCoreLandingPage as Configuration,
		...layoutsCoreSiteSearchPageSponsorship as Configuration,
		...layoutsCoreSweepstakesSponsorship as Configuration,
		...layoutsCoreSweepstakes as Configuration,
		...layoutsCoreUniversalLandingPage as Configuration,
		...layoutsCoreFullWidthPage as Configuration,
		...layoutsCoreHome as Configuration,
		...layoutsCoreSitemap as Configuration,
		...layoutsDTCWebCommon as Configuration,
		...layoutsCoreGaladVerticalPhotoGallery as Configuration,
		...layoutsShowPage as Configuration,
		...layoutsFoodcomCommon as Configuration,
		...layoutsFoodcomHome as Configuration,
		...layoutsFoodcomRecipe as Configuration,
		...layoutsFoodcomSCC3 as Configuration,
		...layoutsFoodcomSitemap as Configuration,
		...layoutsFoodcomFoodDictionary as Configuration,
		...layoutsFoodcomCardLayout as Configuration,
	];

	return [
		...targetingWhitelist as Configuration,
		...slotDefinitions as Configuration,
		// ...slotDefinitionsWeb as Configuration,
		// ...slotDefinitionsMobile as Configuration,
		...slotDefinitionsResponsive as Configuration,
		...amazonA9 as Configuration,
		...kronosRules as Configuration,
		...configuration as Configuration,
		...golfConfiguration as Configuration,
		...foodComConfiguration as Configuration,
		...generalRules as Configuration,
		...dfpEnvironment as Configuration,
		...layoutConfiguration,
	];
}